
import { Box } from '@mui/material';
import React from 'react';
const FeedbackIcon: React.FC<Props> = ({
  children,
  className,
  size = 'is-normal',
  variant = 'is-primary',
  isLight = false,
  fullWidth,
  backgroundColor,
  color,
  status,
  ...props
}) => {
  return (
    <>
      <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.62521 17.125H7.37521C7.04369 17.125 6.72574 16.9933 6.49132 16.7589C6.2569 16.5245 6.12521 16.2065 6.12521 15.875L6.12716 12.5227C6.1272 12.4952 6.12001 12.4682 6.10631 12.4444C6.09262 12.4207 6.07289 12.4009 6.04913 12.3872C6.02537 12.3734 5.99842 12.3662 5.97097 12.3662C5.94352 12.3662 5.91655 12.3734 5.89279 12.3871L2.98888 14.0691C2.70646 14.2322 2.37084 14.2764 2.05585 14.192C1.74085 14.1076 1.47227 13.9015 1.30919 13.6191L0.66466 12.5004L0.662316 12.4965C0.503628 12.2142 0.462032 11.8809 0.546473 11.5683C0.630913 11.2556 0.834647 10.9886 1.11388 10.8246L4.02833 9.13516C4.05201 9.12142 4.07166 9.10171 4.08533 9.07799C4.09899 9.05427 4.10618 9.02737 4.10618 9C4.10618 8.97263 4.09899 8.94573 4.08533 8.92201C4.07166 8.89829 4.05201 8.87858 4.02833 8.86484L1.11661 7.17695C0.976418 7.09656 0.853486 6.98927 0.754877 6.86123C0.656268 6.73319 0.583925 6.58694 0.542002 6.43086C0.500079 6.27478 0.489403 6.11196 0.510586 5.95175C0.53177 5.79153 0.584396 5.63708 0.665442 5.49727L1.30763 4.38203C1.38878 4.24104 1.49709 4.11755 1.6263 4.01871C1.75551 3.91988 1.90305 3.84766 2.06036 3.80625C2.21589 3.76451 2.37815 3.75407 2.53774 3.77553C2.69733 3.79699 2.85107 3.84992 2.99005 3.93125L5.89279 5.61094C5.91655 5.62466 5.94352 5.63188 5.97097 5.63187C5.99842 5.63186 6.02537 5.62462 6.04913 5.61088C6.07289 5.59714 6.09262 5.57738 6.10631 5.5536C6.12001 5.52981 6.1272 5.50284 6.12716 5.47539L6.12521 2.125C6.12521 1.79348 6.2569 1.47554 6.49132 1.24112C6.72574 1.0067 7.04369 0.875 7.37521 0.875H8.62521C8.95673 0.875 9.27467 1.0067 9.50909 1.24112C9.74351 1.47554 9.87521 1.79348 9.87521 2.125V5.47344C9.87517 5.50088 9.88236 5.52786 9.89605 5.55164C9.90975 5.57543 9.92947 5.59519 9.95323 5.60893C9.97699 5.62267 10.004 5.62991 10.0314 5.62992C10.0588 5.62993 10.0858 5.62271 10.1096 5.60898L13.0135 3.92695C13.296 3.76423 13.6315 3.72021 13.9464 3.80458C14.2613 3.88894 14.5299 4.09479 14.6932 4.37695L15.3373 5.4957L15.3397 5.49922C15.5002 5.7818 15.5424 6.11638 15.4573 6.43001C15.3721 6.74364 15.1664 7.01087 14.885 7.17344L11.9736 8.86094C11.95 8.87467 11.9303 8.89439 11.9166 8.91811C11.903 8.94183 11.8958 8.96872 11.8958 8.99609C11.8958 9.02347 11.903 9.05036 11.9166 9.07408C11.9303 9.0978 11.95 9.11751 11.9736 9.13125L14.885 10.8187C15.0252 10.8991 15.1481 11.0064 15.2467 11.1345C15.3453 11.2625 15.4177 11.4087 15.4597 11.5648C15.5016 11.7209 15.5123 11.8837 15.4912 12.0439C15.4701 12.2041 15.4175 12.3586 15.3365 12.4984L14.6943 13.6137C14.6132 13.7547 14.5049 13.8782 14.3757 13.977C14.2465 14.0758 14.0989 14.148 13.9416 14.1895C13.7861 14.2312 13.6238 14.2416 13.4642 14.2202C13.3046 14.1987 13.1509 14.1458 13.0119 14.0645L10.1092 12.3848C10.0854 12.3711 10.0585 12.3638 10.0311 12.3638C10.0037 12.3638 9.97676 12.371 9.95301 12.3847C9.92926 12.3984 9.90954 12.4181 9.89581 12.4419C9.88208 12.4656 9.87484 12.4925 9.87482 12.5199L9.87521 15.875C9.87521 16.2065 9.74351 16.5245 9.50909 16.7589C9.27467 16.9933 8.95673 17.125 8.62521 17.125Z" fill="#FF8A5A" />
      </svg>

    </>
  )

}

export type IconVariant =
  | 'is-black'
  | 'is-dark'
  | 'is-light'
  | 'is-white'
  | 'is-primary'
  | 'is-link'
  | 'is-info'
  | 'is-success'
  | 'is-warning'
  | 'is-danger'
  | 'is-customize';

export type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLOrSVGElement>,
  HTMLOrSVGElement
> & {
  variant?: IconVariant;
  isLight?: boolean;
  size?: 'is-normal' | 'is-medium' | 'is-large';
  fullWidth?: boolean;
  backgroundColor?: string;
  color?: string;
  className?: string;
  status?: string;
};
export default FeedbackIcon